import qs from "qs";
import { RedirectKeys } from "@entrilia/shared/auth/authTypes";
import { getAuthSettings } from "@entrilia/shared/auth/settings";
import { pageRoutes } from "../routes";
import { getVariables } from "../variables";

export const redirectToSignin = () => {
  const state = JSON.stringify({
    origin: window.location.origin,
    originalPath: `${window.location.pathname}${window.location.search}`,
  });

  const currentUrl = new URL(window.location.href);
  const promptParam = currentUrl.searchParams.get(RedirectKeys.Prompt);
  if (promptParam) {
    currentUrl.searchParams.delete(RedirectKeys.Prompt);
  }

  const query = qs.stringify({
    client_id: getAuthSettings().clientId,
    nonce: "defaultNonce",
    redirect_uri: `${window.location.origin}/${pageRoutes.oauth}/`,
    scope: `openid offline_access ${getAuthSettings().portalAccessScope}`,
    response_type: "code",
    [RedirectKeys.State]: state,
    [RedirectKeys.Prompt]: promptParam || undefined,
  });

  window.location.href = `${getVariables().MICROSOFT_AUTH_ENDPOINT}?${query}`;
};
